var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgOficina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "79px",
    viewBox: "0 0 81 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_oficina") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-2163.000000, -448.000000)",
    stroke: "",
    strokeWidth: 5.6424357
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_oficina",
    transform: "translate(2166.000002, 451.710592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5175439,47.1644084 C31.3014336,47.1644084 26.2622807,42.0716475 26.2622807,35.7894084 C26.2622807,29.5071693 31.3014336,24.4144084 37.5175439,24.4144084 C43.7336541,24.4144084 48.772807,29.5071693 48.772807,35.7894084 C48.772807,42.0716475 43.7336541,47.1644084 37.5175439,47.1644084 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,32.452499 C0,28.5091658 3.18899176,25.2483356 7.12833369,25.2483356 C13.9190089,25.2483356 16.695307,20.395001 13.2812104,14.4420841 C11.3302982,11.0295842 12.4933411,6.59333393 15.9074377,4.62166734 L22.3979729,0.867917417 C25.3618589,-0.914165912 29.1886491,0.147501099 30.9519737,3.14291785 L31.3646654,3.86333383 C34.7412442,9.81625069 40.2938406,9.81625069 43.7079372,3.86333383 L44.1206324,3.14291785 C45.883957,0.147501099 49.710749,-0.914165912 52.674635,0.867917417 L59.1651684,4.62166734 C62.579265,6.59333393 63.7423044,11.0295842 61.7913922,14.4420841 C58.3772956,20.395001 61.153599,25.2483356 67.9442742,25.2483356 C71.8460986,25.2483356 75.0726061,28.4712492 75.0726061,32.452499 L75.0726061,39.1258332 C75.0726061,43.0691664 71.8836161,46.3299984 67.9442742,46.3299984 C61.153599,46.3299984 58.3772956,51.1833294 61.7913922,57.1362462 C63.7423044,60.586663 62.579265,64.9850005 59.1651684,66.9566671 L52.674635,70.7104162 C49.710749,72.4924996 45.883957,71.4308388 44.1206324,68.435422 L43.7079372,67.7150033 C40.3313583,61.7620865 34.778762,61.7620865 31.3646654,67.7150033 L30.9519737,68.435422 C29.1886491,71.4308388 25.3618589,72.4924996 22.3979729,70.7104162 L15.9074377,66.9566671 C12.4933411,64.9850005 11.3302982,60.5487462 13.2812104,57.1362462 C16.695307,51.1833294 13.9190089,46.3299984 7.12833369,46.3299984 C3.18899176,46.3299984 0,43.0691664 0,39.1258332 L0,32.452499 Z",
    id: "Vector",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgOficina);
export default __webpack_public_path__ + "static/media/svg_oficina.2f6d05b35bab3a5cdf1a3ac537d2c421.svg";
export { ForwardRef as ReactComponent };